import { useState } from "react";
import { Button, useToast } from "@chakra-ui/react";

interface SubmitApplicationButtonProps {
  onLoading?: (loading: boolean) => void;
  beforeSubmit?: () => Promise<boolean>;
}

export function SubmitApplicationButton({ onLoading, beforeSubmit }: SubmitApplicationButtonProps) {
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      onLoading?.(true);

      // Run any pre-submission tasks
      if (beforeSubmit) {
        const success = await beforeSubmit();
        if (!success) {
          return;
        }
      }
    } catch (error: any) {
      toast({
        title: "Error occurred",
        description: error.message,
        status: "error",
      });
    } finally {
      setIsLoading(false);
      onLoading?.(false);
    }
  };

  return (
    <>
      <Button
        colorScheme="blue"
        onClick={handleSubmit}
        isLoading={isLoading}
        height="35px"
        borderRadius="7px"
        fontSize="14px"
        fontWeight="500"
      >
        Submit Application
      </Button>
    </>
  );
}
